export default class RatePlan {
  constructor(obj) {
    this.id = obj.id ? obj.id : 0;
    this.ratePlanId = obj.ratePlanId ? obj.ratePlanId : 0;
    this.ratePlanDescription = obj.ratePlanDescription
      ? obj.ratePlanDescription
      : "";
    this.groupName = obj.groupName ? obj.groupName : null;
    this.usageType = obj.usageType ? obj.usageType : "";
    this.productType = obj.productType ? obj.productType : "";
    this.handset = obj.handset ? obj.handset : false;
    this.monthlyRetail = obj.monthlyRetail ? obj.monthlyRetail : 0.0;
    this.monthlyProfitPercent = obj.monthlyProfitPercent
      ? obj.monthlyProfitPercent
      : 0.0;
    this.ratePlanPdf = obj.ratePlanPdf ? obj.ratePlanPdf : "";
    this.dataAllowance = obj.dataAllowance ? obj.dataAllowance : 0;
    this.monitorDataUsage = obj.monitorDataUsage ? obj.monitorDataUsage : false;
    this.contractMonths = obj.contractMonths ? obj.contractMonths : 0;
    this.payInitialComms = obj.payInitialComms ? obj.payInitialComms : true;
    this.hasSpecialOverride = obj.hasSpecialOverride
      ? obj.hasSpecialOverride
      : false;
    this.qantasBonusPoints = obj.qantasBonusPoints
      ? obj.qantasBonusPoints
      : null;
    this.qantasPlan = obj.qantasPlan ? obj.qantasPlan : null;
    this.qantasPoints = obj.qantasPoints ? obj.qantasPoints : null;
    this.qantasStatementText = obj.qantasStatementText
      ? obj.qantasStatementText
      : null;
    this.excessDataCharge = obj.excessDataCharge ? obj.excessDataCharge : 0;
    this.forcePayInitial = obj.forcePayInitial ? obj.forcePayInitial : false;
  }
}
